import {
  buildSearchEngine,
  getSampleSearchEngineConfiguration
} from '@coveo/headless';

// eslint-disable-next-line import/prefer-default-export
export function coveoSearchEngine(
  organizationID,
  apiKey,
  pipeline,
  searchHub,
  debug = true
) {
  const engine = buildSearchEngine({
    configuration:
      organizationID && apiKey
        ? {
          organizationId: organizationID,
          accessToken: apiKey,
          search: {
            pipeline,
            searchHub
          }
        }
        : getSampleSearchEngineConfiguration(), // for testing purposes
    loggerOptions: debug ? { level: 'info' } : { level: 'error' }
  });

  return engine;
}
